import React, {useState} from 'react';
import __ from "lodash";
import {Toolbar} from "@material-ui/core";
import {ChromeTabs} from '../../controls';

const ViewJetplans = (props) => {
  const {planData} = props; 
  const [currentTab, setCurrentTab] = useState('planText');

  const tabs = [{label: `Base Plan`, value: "planText"}];
  if (__.has(planData, 'planTextTanker') && planData.planTextTanker) tabs.push({label: `Tankering Plan`, value: "planTextTanker"});

  const handleTabChange = (e, i) => {
    setCurrentTab(i);
  }

  return (
    <div>
      {tabs.length > 1 &&
        <Toolbar>
          <ChromeTabs
            id={"ViewCostingJetPlans"}
            style={{ alignSelf: "flex-end" }}
            tabs={tabs}
            tabStyle={{
              bgColor: "#E6E8EB",
              selectedBgColor: "#ffffff",
              color: "rgba(0,0,0,0.87)",
            }}
            tabProps={{
              disableRipple: false,
            }}
            value={currentTab}
            onChange={handleTabChange}          
          />
        </Toolbar>
      } 
      {Array.isArray(planData[currentTab])?
        <div style={{lineHeight: 1, fontSize:"14px", fontFamily: "monospace", color: "#202020", whiteSpace: "pre", backgroundColor: "#ffffff"}}>
          {planData[currentTab].map(line => (
            <div>{line}</div>
          ))}
        </div>
      : planData[currentTab]?.error ?
        <div style={{lineHeight: 1, fontSize:"16px", color: "#202020", backgroundColor: "#ffffff", width: 600, minHeight: 200, padding: '50px 40px'}}>
          <div style={{textAlign: 'center', width: '100%', paddingBottom: 40, fontSize: 20, fontWeight: 'bold'}}>An error occurred building the jetplan:</div>  
          <div><div style={{display: 'inline-block', width: 120, fontWeight: '500'}}>Error Code:</div><div style={{display: 'inline-block'}}>{planData[currentTab]?.error?.code}</div></div>  
          <div><div style={{display: 'inline-block', width: 120, fontWeight: '500'}}>Error Text:</div><div style={{display: 'inline-block'}}>{planData[currentTab]?.error?.text}</div></div>  
          <div><div style={{display: 'inline-block', width: 120, fontWeight: '500'}}>Description:</div><div style={{display: 'inline-block'}}>{planData[currentTab]?.error?.translated}</div></div>  
        </div>
      : 
        <div style={{lineHeight: 1, fontSize:"20px", color: "#202020", backgroundColor: "#ffffff", width: 600, minHeight: 200, padding: '50px 40px'}}>
          <div style={{textAlign: 'center', width: '100%'}}>There does not appear to be any plan result to show</div>  
        </div>
      }
    </div>
  );
}

const viewJetplansPopup = (planData, title, SystemData) => {
  console.log(planData);
  SystemData.openAlert(
    `${title}`,
    (
      <ViewJetplans planData={planData}/>
    ),
    {zIndex: 5000, maxWidth: 300, fullWidth: false, dialogStyle:{backgroundColor: "rgb(240, 240, 240)"}}
  );
}

export default ViewJetplans;
export {viewJetplansPopup};